var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "  person"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18824 0.320068H7.81153C7.7184 0.320068 7.62531 0.32394 7.5325 0.331675C5.68323 0.48578 4.30903 2.10983 4.46314 3.9591L4.62078 5.85085C4.76724 7.60828 6.23636 8.96007 7.99989 8.96007C9.76341 8.96007 11.2325 7.60828 11.379 5.85085L11.5366 3.9591C11.5444 3.86629 11.5482 3.7732 11.5482 3.68007C11.5482 1.82439 10.0439 0.320068 8.18824 0.320068Z",
    fill: "#191A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.744 9.40412C10.762 10.3209 9.4442 10.8801 7.99989 10.8801C6.55557 10.8801 5.23774 10.3209 4.25574 9.40412L2.56708 10.0374C1.21538 10.5443 0.319885 11.8365 0.319885 13.2801V14.7201C0.319885 15.2503 0.749692 15.6801 1.27989 15.6801H14.7199C15.2501 15.6801 15.6799 15.2503 15.6799 14.7201V13.2801C15.6799 11.8365 14.7844 10.5443 13.4327 10.0374L11.744 9.40412Z",
    fill: "#191A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.02e3bab44fbc1d63838978879200da79.svg";
export { ForwardRef as ReactComponent };